import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import Layout from "../../components/Layout";
import Cards from "../../components/Cards";
import useFetchWithScroll from "../../hooks/useFetchWithScroll";
import { API_KEY } from "../../utils/constants";

const SingleGenres = () => {
  const { id, name } = useParams();
  const [page, setPage] = useState(1);

  const { data, totalPage, isFetching } = useFetchWithScroll(
    `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&language=en-US&with_genres=${id}&page=${page}&sort_by=popularity.desc`,
    page,
    setPage
  );

  return (
    <Layout title={name}>
      <Cards
        title={name}
        data={data}
        isFetching={isFetching}
        page={page}
        totalPage={totalPage}
      />
    </Layout>
  );
};

export default SingleGenres;
